/** Generate a unique estimate number: EST-YYYYMMDD-#### */
export function generateEstimateNumber() {
    const date = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    const rand = Math.floor(1000 + Math.random() * 9000);
    return `EST-${date}-${rand}`;
}
